import './styles.css';

let mediaBunnyPromise;
function loadMediaBunny() {
  if (!mediaBunnyPromise) mediaBunnyPromise = import('mediabunny');
  return mediaBunnyPromise;
}

const app = document.querySelector('#app');
const TEMP_PREFIX = 'apoorv-ytd-';
const MEMORY_INPUT_LIMIT = 350 * 1024 * 1024;
const state = {
  info: null,
  mode: 'video',
  selectedVideo: null,
  selectedAudio: null,
  busy: false
};

app.innerHTML = `
  <section class="shell">
    <header class="topbar">
      <a class="brand" href="/" aria-label="Apoorv's YouTube Video Down home">apoorv's youtube video down</a>
      <span class="domain">ytb.apoorv.sbs</span>
    </header>

    <section class="hero" aria-labelledby="page-title">
      <p class="eyebrow">YouTube downloader</p>
      <h1 id="page-title">Paste. Pick. Download.</h1>
      <p class="lede">Video up to the source's maximum quality, with audio. Or switch to audio only.</p>

      <form id="url-form" class="url-form">
        <label class="sr-only" for="youtube-url">YouTube video URL</label>
        <input id="youtube-url" name="url" type="url" inputmode="url" autocomplete="off" placeholder="https://youtube.com/watch?v=..." required />
        <button id="analyze-button" type="submit">Get video</button>
      </form>
      <p id="message" class="message" role="status" aria-live="polite"></p>
    </section>

    <section id="result" class="result hidden" aria-live="polite">
      <article class="video-card">
        <img id="thumbnail" alt="" />
        <div class="video-copy">
          <h2 id="video-title"></h2>
          <p id="video-meta"></p>
        </div>
      </article>

      <div class="mode-switch" role="tablist" aria-label="Download type">
        <button class="mode active" type="button" data-mode="video" role="tab" aria-selected="true">Video</button>
        <button class="mode" type="button" data-mode="audio" role="tab" aria-selected="false">Audio only</button>
      </div>

      <div class="picker">
        <div class="picker-row">
          <span class="picker-label">Quality</span>
          <div id="quality-options" class="quality-options"></div>
        </div>
        <button id="download-button" class="download-button" type="button" disabled>Download</button>
      </div>

      <div id="progress-wrap" class="progress-wrap hidden" aria-live="polite">
        <div class="progress-line"><span id="progress-label">Preparing…</span><span id="progress-value">0%</span></div>
        <div class="progress-track"><span id="progress-bar"></span></div>
      </div>
    </section>

    <footer>
      <span>Fast, minimal, no account.</span>
      <span>Only download content you have permission to save.</span>
    </footer>
  </section>
`;

const form = document.querySelector('#url-form');
const urlInput = document.querySelector('#youtube-url');
const analyzeButton = document.querySelector('#analyze-button');
const message = document.querySelector('#message');
const result = document.querySelector('#result');
const thumbnail = document.querySelector('#thumbnail');
const videoTitle = document.querySelector('#video-title');
const videoMeta = document.querySelector('#video-meta');
const qualityOptions = document.querySelector('#quality-options');
const downloadButton = document.querySelector('#download-button');
const progressWrap = document.querySelector('#progress-wrap');
const progressLabel = document.querySelector('#progress-label');
const progressValue = document.querySelector('#progress-value');
const progressBar = document.querySelector('#progress-bar');

function formatDuration(seconds) {
  if (!Number.isFinite(seconds) || seconds <= 0) return '';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  return h ? `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}` : `${m}:${String(s).padStart(2, '0')}`;
}

function formatBytes(bytes) {
  if (!bytes) return '';
  const units = ['B', 'KB', 'MB', 'GB'];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value >= 10 || unit === 0 ? value.toFixed(0) : value.toFixed(1)} ${units[unit]}`;
}

function safeName(value) {
  return String(value || 'youtube-download')
    .normalize('NFKD')
    .replace(/[\\/:*?"<>|\u0000-\u001f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 120) || 'youtube-download';
}

function setMessage(text, kind = '') {
  message.textContent = text;
  message.dataset.kind = kind;
}

function setProgress(value, label) {
  const safe = Math.max(0, Math.min(100, Math.round(value)));
  progressWrap.classList.remove('hidden');
  progressBar.style.width = `${safe}%`;
  progressValue.textContent = `${safe}%`;
  if (label) progressLabel.textContent = label;
}

function resetProgress() {
  progressWrap.classList.add('hidden');
  progressBar.style.width = '0%';
  progressValue.textContent = '0%';
  progressLabel.textContent = 'Preparing…';
}

function renderQualityOptions() {
  const options = state.mode === 'video' ? state.info.video : state.info.audio;
  const selected = state.mode === 'video' ? state.selectedVideo : state.selectedAudio;
  qualityOptions.innerHTML = '';

  options.forEach((option, index) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'quality';
    const id = state.mode === 'video' ? `${option.video.itag}:${option.audio?.itag || 0}` : String(option.format.itag);
    const selectedId = state.mode === 'video'
      ? state.selectedVideo && `${state.selectedVideo.video.itag}:${state.selectedVideo.audio?.itag || 0}`
      : state.selectedAudio && String(state.selectedAudio.format.itag);

    button.classList.toggle('active', id === selectedId || (!selected && index === 0));
    button.innerHTML = state.mode === 'video'
      ? `<strong>${option.label}</strong><span>video + audio${option.estimatedBytes ? ` · ${formatBytes(option.estimatedBytes)}` : ''}</span>`
      : `<strong>${option.label}</strong><span>~${option.kbps} kbps · ${option.format.extension.toUpperCase()}</span>`;

    button.addEventListener('click', () => {
      if (state.mode === 'video') state.selectedVideo = option;
      else state.selectedAudio = option;
      renderQualityOptions();
      downloadButton.disabled = false;
    });
    qualityOptions.append(button);
  });

  if (!selected && options.length) {
    if (state.mode === 'video') state.selectedVideo = options[0];
    else state.selectedAudio = options[0];
    renderQualityOptions();
    return;
  }

  downloadButton.disabled = !options.length || state.busy;
}

function renderInfo(info) {
  state.info = info;
  state.selectedVideo = info.video[0] || null;
  state.selectedAudio = info.audio.at(-1) || info.audio[0] || null;
  thumbnail.src = info.thumbnail;
  thumbnail.alt = `Thumbnail for ${info.title}`;
  videoTitle.textContent = info.title;
  videoMeta.textContent = [info.author, formatDuration(info.duration)].filter(Boolean).join(' · ');
  result.classList.remove('hidden');
  resetProgress();
  renderQualityOptions();
}

form.addEventListener('submit', async (event) => {
  event.preventDefault();
  const value = urlInput.value.trim();
  if (!value) return;

  analyzeButton.disabled = true;
  analyzeButton.textContent = 'Reading…';
  result.classList.add('hidden');
  setMessage('Checking available qualities…');

  try {
    const response = await fetch(`/api/info?url=${encodeURIComponent(value)}`, { cache: 'no-store' });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Could not read that video.');
    renderInfo(data);
    const max = data.video[0]?.label;
    setMessage(max ? `Ready. Maximum available video quality: ${max}.` : 'Ready for audio download.', 'success');
  } catch (error) {
    setMessage(error.message || 'Could not read that video.', 'error');
  } finally {
    analyzeButton.disabled = false;
    analyzeButton.textContent = 'Get video';
  }
});

document.querySelectorAll('.mode').forEach((button) => {
  button.addEventListener('click', () => {
    if (state.busy || !state.info) return;
    state.mode = button.dataset.mode;
    document.querySelectorAll('.mode').forEach((item) => {
      const active = item === button;
      item.classList.toggle('active', active);
      item.setAttribute('aria-selected', String(active));
    });
    resetProgress();
    renderQualityOptions();
  });
});

function streamUrl(format, download = false, name = '') {
  const params = new URLSearchParams({
    id: state.info.id,
    itag: String(format.itag),
    kind: format.kind
  });
  if (download) {
    params.set('download', '1');
    params.set('name', name);
  }
  return `/api/stream?${params.toString()}`;
}

async function getOpfsRoot() {
  if (!navigator.storage?.getDirectory) return null;
  try {
    return await navigator.storage.getDirectory();
  } catch {
    return null;
  }
}

async function cleanupOldTempFiles() {
  const root = await getOpfsRoot();
  if (!root?.entries) return;
  try {
    for await (const [name] of root.entries()) {
      if (name.startsWith(TEMP_PREFIX)) {
        try { await root.removeEntry(name); } catch { /* stale file cleanup is best effort */ }
      }
    }
  } catch {
    // Some browsers expose OPFS but not async directory iteration.
  }
}
cleanupOldTempFiles();

async function readError(response, fallback) {
  try {
    const text = await response.text();
    return text || fallback;
  } catch {
    return fallback;
  }
}

const HTTP_CHUNK_SIZE = 8 * 1024 * 1024;
const HTTP_CHUNK_CONCURRENCY = 3;

function delay(ms, signal) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(resolve, ms);
    if (!signal) return;
    if (signal.aborted) {
      clearTimeout(timer);
      reject(new DOMException('Aborted', 'AbortError'));
      return;
    }
    signal.addEventListener('abort', () => {
      clearTimeout(timer);
      reject(new DOMException('Aborted', 'AbortError'));
    }, { once: true });
  });
}

async function fetchMediaRequest(format, signal, range = null) {
  const headers = range ? { Range: `bytes=${range.start}-${range.end}` } : {};
  let lastError = null;

  for (let attempt = 0; attempt < 2; attempt += 1) {
    const response = await fetch(streamUrl(format), {
      cache: 'no-store',
      signal,
      headers
    });

    if (response.ok) return response;

    const errorText = await readError(response, `Could not download ${format.kind} source.`);
    lastError = new Error(errorText);
    if (attempt === 0 && (response.status === 429 || response.status >= 500)) {
      const retryAfter = Math.max(1, Number(response.headers.get('Retry-After')) || 1);
      await delay(Math.min(5000, retryAfter * 1000), signal);
      continue;
    }
    throw lastError;
  }

  throw lastError || new Error(`Could not download ${format.kind} source.`);
}

async function fetchRangedChunk(format, start, end, signal) {
  const response = await fetchMediaRequest(format, signal, { start, end });
  if (response.status !== 206) {
    try { await response.body?.cancel(); } catch { /* best effort */ }
    throw new Error('Media source did not honor ranged downloading. Try again.');
  }

  const contentRange = response.headers.get('Content-Range') || '';
  const match = /^bytes\s+(\d+)-(\d+)\/(\d+|\*)$/i.exec(contentRange);
  if (!match || Number(match[1]) !== start || Number(match[2]) !== end) {
    try { await response.body?.cancel(); } catch { /* best effort */ }
    throw new Error('Media source returned an invalid byte range. Try again.');
  }

  const data = new Uint8Array(await response.arrayBuffer());
  if (data.byteLength !== end - start + 1) {
    throw new Error('Media source returned an incomplete byte range. Try again.');
  }
  return data;
}

async function fetchChunkedMediaAsset(format, expected, root, onProgress, signal) {
  const ranges = [];
  for (let start = 0; start < expected; start += HTTP_CHUNK_SIZE) {
    ranges.push({ start, end: Math.min(expected - 1, start + HTTP_CHUNK_SIZE - 1) });
  }

  let handle = null;
  let writable = null;
  let entryName = '';
  const memoryChunks = [];
  if (root) {
    entryName = `${TEMP_PREFIX}${crypto.randomUUID()}.${format.extension}`;
    handle = await root.getFileHandle(entryName, { create: true });
    writable = await handle.createWritable();
  }

  let received = 0;
  try {
    for (let index = 0; index < ranges.length; index += HTTP_CHUNK_CONCURRENCY) {
      const batch = ranges.slice(index, index + HTTP_CHUNK_CONCURRENCY);
      const chunks = await Promise.all(batch.map(({ start, end }) => {
        return fetchRangedChunk(format, start, end, signal);
      }));

      for (const chunk of chunks) {
        if (writable) await writable.write(chunk);
        else memoryChunks.push(chunk);
        received += chunk.byteLength;
        onProgress(Math.min(1, received / expected));
      }
    }

    if (writable) {
      await writable.close();
      onProgress(1);
      return {
        file: await handle.getFile(),
        cleanup: async () => {
          try { await root.removeEntry(entryName); } catch { /* best effort */ }
        }
      };
    }

    onProgress(1);
    return { file: new Blob(memoryChunks, { type: format.mimeType }), cleanup: async () => {} };
  } catch (error) {
    if (writable) {
      try { await writable.abort(); } catch { /* best effort */ }
      try { await root.removeEntry(entryName); } catch { /* best effort */ }
    }
    throw error;
  }
}

async function fetchMediaAsset(format, onProgress, signal) {
  const expected = Number(format.contentLength) || 0;
  const root = await getOpfsRoot();

  if (expected > HTTP_CHUNK_SIZE) {
    if (!root && expected > MEMORY_INPUT_LIMIT) {
      throw new Error('This browser cannot store this source safely in memory. Use a browser with Origin Private File System support or choose a lower quality.');
    }
    return fetchChunkedMediaAsset(format, expected, root, onProgress, signal);
  }

  const response = await fetchMediaRequest(format, signal);
  if (!response.body) throw new Error(`Browser did not expose the ${format.kind} stream body.`);

  const responseExpected = Number(response.headers.get('Content-Length')) || expected;
  if (root) {
    const entryName = `${TEMP_PREFIX}${crypto.randomUUID()}.${format.extension}`;
    const handle = await root.getFileHandle(entryName, { create: true });
    const writable = await handle.createWritable();
    const reader = response.body.getReader();
    let received = 0;
    try {
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        await writable.write(value);
        received += value.byteLength;
        if (responseExpected) onProgress(Math.min(1, received / responseExpected));
      }
      await writable.close();
      onProgress(1);
      return {
        file: await handle.getFile(),
        cleanup: async () => {
          try { await root.removeEntry(entryName); } catch { /* best effort */ }
        }
      };
    } catch (error) {
      try { await writable.abort(); } catch { /* best effort */ }
      try { await root.removeEntry(entryName); } catch { /* best effort */ }
      throw error;
    } finally {
      try { reader.releaseLock(); } catch { /* best effort */ }
    }
  }

  if (responseExpected > MEMORY_INPUT_LIMIT) {
    try { await response.body.cancel(); } catch { /* best effort */ }
    throw new Error('This browser cannot store this source safely in memory. Use a browser with Origin Private File System support or choose a lower quality.');
  }

  const reader = response.body.getReader();
  const chunks = [];
  let received = 0;
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    chunks.push(value);
    received += value.byteLength;
    if (responseExpected) onProgress(Math.min(1, received / responseExpected));
  }
  onProgress(1);
  return { file: new Blob(chunks, { type: format.mimeType }), cleanup: async () => {} };
}

function triggerBlobDownload(blob, filename) {
  const href = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = href;
  anchor.download = filename;
  anchor.style.display = 'none';
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(href), 120_000);
}

async function createOutputSink(filename, mime, estimatedBytes) {
  const { BufferTarget, StreamTarget } = await loadMediaBunny();
  if ('showSaveFilePicker' in window) {
    const handle = await window.showSaveFilePicker({
      suggestedName: filename,
      types: [{ description: 'MP4 video', accept: { [mime]: [`.${filename.split('.').at(-1)}`] } }]
    });
    const writable = await handle.createWritable();
    return {
      target: new StreamTarget(writable, { chunked: true, chunkSize: 4 * 1024 * 1024 }),
      complete: async () => {},
      abort: async () => {
        try { await writable.abort(); } catch { /* best effort */ }
      }
    };
  }

  const root = await getOpfsRoot();
  if (root) {
    const entryName = `${TEMP_PREFIX}output-${crypto.randomUUID()}.mp4`;
    const handle = await root.getFileHandle(entryName, { create: true });
    const writable = await handle.createWritable();
    return {
      target: new StreamTarget(writable, { chunked: true, chunkSize: 4 * 1024 * 1024 }),
      complete: async () => {
        const file = await handle.getFile();
        triggerBlobDownload(file, filename);
        setTimeout(() => root.removeEntry(entryName).catch(() => {}), 180_000);
      },
      abort: async () => {
        try { await writable.abort(); } catch { /* best effort */ }
        try { await root.removeEntry(entryName); } catch { /* best effort */ }
      }
    };
  }

  if ((estimatedBytes || 0) > MEMORY_INPUT_LIMIT) {
    throw new Error('This browser cannot safely create a file this large. Choose a lower quality or use a browser with disk-backed storage support.');
  }
  const bufferTarget = new BufferTarget();
  return {
    target: bufferTarget,
    complete: async () => {
      if (!bufferTarget.buffer) throw new Error('The output file was empty.');
      triggerBlobDownload(new Blob([bufferTarget.buffer], { type: mime }), filename);
    },
    abort: async () => {}
  };
}

async function mergedDownload(option) {
  const { ALL_FORMATS, BlobSource, Conversion, Input, Mp4OutputFormat, Output, WebMOutputFormat } = await loadMediaBunny();
  const filename = `${safeName(state.info.title)}.${option.container}`;
  const mime = option.container === 'mp4' ? 'video/mp4' : 'video/webm';
  const sink = await createOutputSink(filename, mime, option.estimatedBytes);
  const controller = new AbortController();
  let videoAsset = null;
  let audioAsset = null;
  let output = null;
  let videoInput = null;
  let audioInput = null;

  const videoBytes = Number(option.video.contentLength) || 1;
  const audioBytes = Number(option.audio.contentLength) || 1;
  const sourceTotal = videoBytes + audioBytes;
  let videoFetchProgress = 0;
  let audioFetchProgress = 0;
  const updateFetchProgress = () => {
    const weighted = (videoFetchProgress * videoBytes + audioFetchProgress * audioBytes) / sourceTotal;
    setProgress(Math.max(1, weighted * 62), 'Downloading source video + audio…');
  };

  try {
    [videoAsset, audioAsset] = await Promise.all([
      fetchMediaAsset(option.video, (value) => {
        videoFetchProgress = value;
        updateFetchProgress();
      }, controller.signal),
      fetchMediaAsset(option.audio, (value) => {
        audioFetchProgress = value;
        updateFetchProgress();
      }, controller.signal)
    ]);

    setProgress(63, 'Combining video + audio…');
    videoInput = new Input({ formats: ALL_FORMATS, source: new BlobSource(videoAsset.file) });
    audioInput = new Input({ formats: ALL_FORMATS, source: new BlobSource(audioAsset.file) });
    output = new Output({
      format: option.container === 'mp4' ? new Mp4OutputFormat() : new WebMOutputFormat(),
      target: sink.target
    });

    const videoConversion = await Conversion.init({
      input: videoInput,
      output,
      composable: true,
      copy: { mode: 'forced', shiftTolerance: Infinity },
      showWarnings: false,
      audio: { discard: true }
    });
    const audioConversion = await Conversion.init({
      input: audioInput,
      output,
      composable: true,
      copy: { mode: 'forced', shiftTolerance: Infinity },
      showWarnings: false,
      video: { discard: true }
    });

    if (!videoConversion.isValid || !audioConversion.isValid) {
      throw new Error('This browser cannot combine the selected source streams. Try another quality.');
    }

    let videoProgress = 0;
    let audioProgress = 0;
    const updateMuxProgress = () => {
      setProgress(63 + (videoProgress * 0.8 + audioProgress * 0.2) * 36, 'Combining video + audio…');
    };
    videoConversion.onProgress = (value) => {
      videoProgress = value;
      updateMuxProgress();
    };
    audioConversion.onProgress = (value) => {
      audioProgress = value;
      updateMuxProgress();
    };

    await output.start();
    await Promise.all([videoConversion.execute(), audioConversion.execute()]);
    await output.finalize();
    await sink.complete();
    setProgress(100, 'Done');
  } catch (error) {
    controller.abort();
    if (output && output.state !== 'finalized' && output.state !== 'canceled') {
      try { await output.cancel(); } catch { /* best effort */ }
    }
    await sink.abort();
    throw error;
  } finally {
    videoInput?.dispose();
    audioInput?.dispose();
    await Promise.allSettled([videoAsset?.cleanup?.(), audioAsset?.cleanup?.()]);
  }
}

function startDirectDownload(format, filename) {
  const anchor = document.createElement('a');
  anchor.href = streamUrl(format, true, filename);
  anchor.download = '';
  anchor.style.display = 'none';
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
}

downloadButton.addEventListener('click', async () => {
  if (!state.info || state.busy) return;
  state.busy = true;
  downloadButton.disabled = true;
  downloadButton.textContent = 'Working…';
  resetProgress();

  try {
    if (state.mode === 'audio') {
      const option = state.selectedAudio;
      if (!option) throw new Error('Choose an audio quality first.');
      setProgress(100, 'Starting download…');
      startDirectDownload(option.format, safeName(state.info.title));
      setMessage(`Downloading ${option.label.toLowerCase()} audio (~${option.kbps} kbps).`, 'success');
      return;
    }

    const option = state.selectedVideo;
    if (!option) throw new Error('Choose a video quality first.');
    setProgress(1, 'Preparing source streams…');
    await mergedDownload(option);
    setMessage(`${option.label} video is ready.`, 'success');
  } catch (error) {
    if (error?.name === 'AbortError') {
      setMessage('Download canceled.');
    } else {
      setMessage(error.message || 'Download failed. Try another quality.', 'error');
    }
    resetProgress();
  } finally {
    state.busy = false;
    downloadButton.disabled = false;
    downloadButton.textContent = 'Download';
  }
});
